<template>
  <div class="dynamics-tab">
    <div class="dynamics-toolbar">
      <div class="step-switch">
        <button
          v-for="option in STEPS"
          :key="option.id"
          class="step-btn"
          type="button"
          :class="{ active: step === option.id }"
          @click="$emit('update:step', option.id)"
        >
          {{ option.label }}
        </button>
      </div>
      <div v-if="hourCapExceeded" class="cap-hint">
        Для шага «час» период должен быть не длиннее ~41 дня — иначе корзин больше
        1000. Сузьте период или выберите шаг «день».
      </div>
    </div>
    <TemporalTripsTab :rows="rows" :is-loading="isLoading" />
  </div>
</template>

<script>
import TemporalTripsTab from './TemporalTripsTab.vue';

const STEPS = [
  { id: 'hour', label: 'Час' },
  { id: 'day', label: 'День' },
  { id: 'week', label: 'Неделя' },
];

export default {
  name: 'DynamicsTab',
  components: { TemporalTripsTab },
  props: {
    step: { type: String, default: 'day' },
    rows: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
    hourCapExceeded: { type: Boolean, default: false },
  },
  emits: ['update:step'],
  setup() {
    return { STEPS };
  },
};
</script>

<style scoped>
.dynamics-tab {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.dynamics-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.step-switch {
  display: flex;
  gap: 6px;
}

.step-btn {
  padding: 7px 14px;
  font-size: 13px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #fff;
  color: #475467;
  cursor: pointer;
}

.step-btn:hover {
  background: #f8fafc;
}

.step-btn.active {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #007bff;
  font-weight: 600;
}

.cap-hint {
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffcf5;
  border: 1px solid #fef0c7;
  color: #93370d;
  font-size: 13px;
}
</style>
